import React, {
  useState,
  useEffect,
  useContext,
} from 'react';
import { Field, Form } from 'react-final-form';
import { Col } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap,
} from '@/shared/components/Card';
import { renderMaskedField } from '@/shared/components/form/FormField';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
} from '@/shared/components/form/FormElements';
import Select from 'react-select';
import { Button } from '@/shared/components/Button';
import PropTypes from 'prop-types';
import { AuthContext } from '../../../../../context/AuthContext';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';

const EditUser = ({ onSubmit, userDetails, loading }) => {
  // console.log(userDetails);
  const [fetchLocationName, setFetchLocationName] = useState([]);
  const [preSelectedLocation, setPreSelectedLocation] = useState([]);
  const { restaurantid, countryId } = useContext(AuthContext);
  const { apiGlobal } = useContext(GlobalVarContext);
  const [selectCountryCode, setSelectCountryCode] = useState({
    value: userDetails.country_code_id,
    label: userDetails.country_code,
  });
   const [country, setCountry] = useState([]);

  const fetchCountryList = async () => {
      try {
        const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
            method: 'POST',
          });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCountry(response?.data);
        } else {
          setCountry([]);
        }
      } catch (error) {
        console.log(error);
      } 
    };
  
    useEffect(() => {
      fetchCountryList();
    }, []);

  useEffect(() => {
    const fetchRestaurantData = async () => {
      if (!restaurantid) {
        console.error('No restaurant selected. Please provide a valid restaurant ID.');
        return;
      }

      const formData = new FormData();
      formData.append('type', 2);
       formData.append('id', restaurantid);
       formData.append('country_id', countryId);

      try {
        const response = await fetch(`${apiGlobal}/restaurant_data_load.php`, {
            method: 'POST',
            body: formData,
          });
        const data = await response.json();

        if (data?.status && data?.message === 'Success') {
          const locationNames = data?.data.map(item => ({
            value: item?.id,
            label: item?.restaurant_name,
          }));
          setFetchLocationName(locationNames);

          const allowedIds = userDetails.locationids
            ? userDetails.locationids.split(',').map(id => id.trim())
            : [];
          const preSelected = locationNames.filter(
            item => allowedIds.includes(item.value.toString()),
          );
          setPreSelectedLocation(preSelected);
        } else {
          console.error('API responded with an error:', data.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Error fetching restaurant data:', error.message);
      }
    };

    fetchRestaurantData();
  }, [restaurantid]);

  // Prepare final initial values with preselected location array (important!)
  const initialFormValues = {
    ...userDetails,
    locationsids: preSelectedLocation, // ✅ This ensures form initial state contains selected options
  };

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>
          </CardTitleWrap>
          <Form
            onSubmit={async (values, form) => {
              // Submit the form
              await onSubmit(values);
              // ✅ Keep the values after submit instead of reset
              form.restart(values); // reset form with submitted values (to persist UI state)
            }}
            initialValues={initialFormValues}
            keepDirtyOnReinitialize
          >
            {({ handleSubmit }) => (
              <FormContainer onSubmit={handleSubmit}>
                <FormHalfContainer>
                  <FormGroup>
                    <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field name="id" component="input" type="hidden" />
                      <Field
                        name="name"
                        component="input"
                        type="text"
                        placeholder="Enter Name"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>

                  <FormGroup>
                    <FormGroupLabel>User Name (Email)<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="username"
                        component="input"
                        type="email"
                        placeholder="Enter UserName/Email"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>

                  <FormGroup>
                    <FormGroupLabel>Mobile No 1<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                        {/* Country Code Select */}
                        <Field
                          name="country_code_id"
                          render={({ input, meta }) => (
                            <div>
                              <Select
                                {...input}
                                options={country.map(item => ({
                                  value: item.id,
                                  label: item.country_code,
                                }))}
                                value={selectCountryCode}
                                onChange={(selected) => {
                                    setSelectCountryCode(selected);
                                    input.onChange(selected.value);
                                  }}
                                    // isLoading={isLoading}
                                placeholder="Code"
                                classNamePrefix="react-select"
                                components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    // borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                              />
                              {meta.touched && meta.error && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                  )}
                            </div>
                            )}
                        />

                        {/* Phone Input */}
                        <Field
                          name="mobile1"
                          render={({ input, meta }) => (
                            <div style={{ flex: 1 }}>
                              <input
                                {...input}
                                type="text"
                                inputMode="numeric"
                                    // pattern="\d{12}"
                                maxLength={12}
                                placeholder="Enter Phone Number"
                                style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  // borderRadius: '5px',
                                  // border: '1px solid gray',
                                }}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                              />
                              {meta.touched && meta.error && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                              )}
                            </div>
                            )}
                        />
                      </div>
                      {/* <Field name="country_code">
                        {({ input, meta }) => (
                          <div>
                            <select
                              {...input}
                              style={{
                                                    height: '45px',
                                                    backgroundColor: 'white',
                                                    border: '1px solid gray',
                                                    width: '100%',
                                                    borderRadius: '5px',
                                                    paddingLeft: '10px',
                                                  }}
                              required
                            >
                              <option value="">Select Country Code</option>
                              {country.map(nation => (
                                <option key={nation.id} value={nation.id}>
                                  {nation.country_code}
                                </option>
                                                                            ))}
                            </select>
                            {meta.touched && meta.error && (
                            <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                                          )}
                          </div>
                                                                        )}
                      </Field>
                      <Field
                        name="mobile1"
                        component={renderMaskedField}
                        type="text"
                        mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                        placeholder="Enter Mobile 1"
                        required
                        style={{ height: '45px' }}
                      /> */}
                    </FormGroupField>
                  </FormGroup>

                  <FormGroup>
                    <FormGroupLabel>Select Allowed Location</FormGroupLabel>
                    <Field
                      name="locationsids"
                      render={({ input }) => (
                        <Select
                          {...input}
                          isMulti
                          isClearable
                          name="locationsids"
                          className="react-select"
                          classNamePrefix="react-select"
                          options={fetchLocationName}
                          value={input.value}
                          placeholder="Select a Location"
                          onChange={(selected) => {
                            input.onChange(selected);
                          }}
                        />
                      )}
                      required
                    />
                  </FormGroup>
                </FormHalfContainer>

                <FormHalfContainer>
                  <FormGroup>
                    <FormGroupLabel>Designation<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="designation"
                        component="input"
                        type="text"
                        placeholder="Enter Designation"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>

                  <FormGroup>
                    <FormGroupLabel>Password<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="password"
                        component="input"
                        type="text"
                        placeholder="Enter Password"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>

                  <FormGroup>
                    <FormGroupLabel>WhatsApp No<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="mobile2"
                        render={({ input, meta }) => (
                          <div style={{ flex: 1 }}>
                            <input
                              {...input}
                              type="text"
                              inputMode="numeric"
                                    // pattern="\d{12}"
                              maxLength={12}
                              placeholder="Enter WhatsApp No"
                              style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  // borderRadius: '5px',
                                  // border: '1px solid gray',
                                }}
                              onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                            />
                            {meta.touched && meta.error && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                              )}
                          </div>
                            )}
                      />
                      {/* <Field
                        name="mobile2"
                        component={renderMaskedField}
                        type="text"
                        mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                        placeholder="Enter WhatsApp no"
                        required
                        style={{ height: '45px' }}
                      /> */}
                    </FormGroupField>
                  </FormGroup>
                </FormHalfContainer>

                <FormButtonToolbar>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Submit
                  </Button>
                </FormButtonToolbar>
              </FormContainer>
            )}
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

EditUser.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  userDetails: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    country_code_id: PropTypes.string.isRequired,
    country_code: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    password: PropTypes.string,
    designation: PropTypes.string,
    locationids: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default EditUser;


// this is the old code for EditUser component, which is not used anymore. 

// import React, { 
//     useState,
//      useEffect, 
//      useContext,
//      useRef,
//     } from 'react';
//   import { Field, Form } from 'react-final-form';
//   import { Col } from 'react-bootstrap';
//   import {
//     Card, CardBody, CardTitleWrap,
//   } from '@/shared/components/Card';
//   import { renderMaskedField } from '@/shared/components/form/FormField';
//   import {
//       FormButtonToolbar,
//       FormContainer,
//       FormGroup,
//       FormGroupField,
//       FormGroupLabel,
//       FormHalfContainer,
//     } from '@/shared/components/form/FormElements';
//     import Select from 'react-select';
//     import { Button } from '@/shared/components/Button';
//     import PropTypes from 'prop-types';
//     import { AuthContext } from '../../../../../context/AuthContext';
//     import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
  
//     const EditUser = ({ onSubmit, userDetails, loading }) => {
//     const [selectedImage, setSelectedImage] = useState(null);
//     const { restaurantid } = useContext(AuthContext);
//     const { apiGlobal } = useContext(GlobalVarContext);
//     const [fetchLocationName, setFetchLocationName] = useState([]);
//     const [preSelectedLocation, setPreSelectedLocation] = useState([]);

//     useEffect(() => {
//         const fetchRestaurantData = async () => {
//           if (!restaurantid) {
//             console.error('No restaurant selected. Please provide a valid restaurant ID.');
//             return;
//           }
    
//           try {
//             const response = await fetch(`${apiGlobal}/restaurant_data_load.php?
//               type=2&id=${restaurantid}`);
//             const data = await response.json();
    
//             if (data?.status && data?.message === 'Success') {
//               const locationNames = data?.data.map(item => ({
//                 value: item?.id,
//                 label: item?.restaurant_name,
//               }));
//               setFetchLocationName(locationNames);

//               const allowedIds = userDetails.locationids
//               .split(',')
//               .map(id => id.trim());
//             const preSelected = locationNames.filter(item => allowedIds.includes(item.value.toString()));
//             setPreSelectedLocation(preSelected);
//             } else {
//               console.error('API responded with an error:', data.message || 'Unknown error');
//             }
//           } catch (error) {
//             console.error('Error fetching restaurant data:', error.message);
//           }
//         };
    
//         fetchRestaurantData();
//       }, [restaurantid]); 

   
//     return (
//       <Col md={12} lg={12}>
//         <Card>
//           <CardBody>
//             <CardTitleWrap>
//               <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>
//             </CardTitleWrap>
//             <Form onSubmit={onSubmit} initialValues={userDetails}>
//               {({ handleSubmit, form }) => (
//                 <FormContainer onSubmit={handleSubmit}>
//                   <FormHalfContainer>
//                     <FormGroup>
//                       <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                       <FormGroupField>
//                         <Field 
//                           name="id"
//                           component="input"
//                           type="hidden"
//                         />
//                         <Field
//                           name="name"
//                           component="input"
//                           type="text"
//                           placeholder="Enter Name"
//                           required
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                     <FormGroup>
//                       <FormGroupLabel>User Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                       <FormGroupField>
//                         <Field
//                           name="username"
//                           component="input"
//                           type="email"
//                           placeholder="Enter UserName"
//                           required
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                     <FormGroup>
//                       <FormGroupLabel>Mobile No 1<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                       <FormGroupField>
//                         <Field
//                           name="mobile1"
//                           component={renderMaskedField}
//                           type="text"
//                           mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
//                           placeholder="Enter Mobile 1"
//                           required
                          
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                     {/* <FormGroup>
//                       <FormGroupLabel>Select Allowed Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                       <Field
//                         name="locationsids"
//                         defaultValue={preSelectedLocation}
//                         initialValue={preSelectedLocation}
//                         render={({ input, meta }) => (
//                           <Select
//                             {...input} 
//                             name="locationsids"
//                             className="react-select"
//                             classNamePrefix="react-select"
//                             isMulti
//                             isClearable
//                             options={fetchLocationName}
//                             value={preSelectedLocation}
//                             placeholder="Select a Location"
//                             onChange={(selected) => {
//                               setPreSelectedLocation(selected); 
//                               input.onChange(selected);
//                             }}
//                           />
//                       )}
//                         required
//                       />
//                     </FormGroup> */}
//                     <FormGroup>
//                       <FormGroupLabel>Select Allowed Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                       <Field
//                         name="locationsids"
//                         initialValue={preSelectedLocation}
//                         render={({ input, meta }) => (
//                           <Select
//                             {...input}
//                             name="locationsids"
//                             className="react-select"
//                             classNamePrefix="react-select"
//                             isMulti
//                             isClearable
//                             options={fetchLocationName}
//                             value={input.value} // ✅ Use form state only
//                             placeholder="Select a Location"
//                             onChange={(selected) => {
//                               input.onChange(selected); // ✅ Update form state only
//                             }}
//                           />
//                         )}
//                         required
//                       />
//                     </FormGroup>
//                   </FormHalfContainer>
//                   <FormHalfContainer>
//                     <FormGroup>
//                       <FormGroupLabel>Designation<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                       <FormGroupField>
//                         <Field
//                           name="designation"
//                           component="input"
//                           type="text"
//                           placeholder="Enter Degisnation"
//                           required
                          
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                     <FormGroup>
//                       <FormGroupLabel>Password<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                       <FormGroupField>
//                         <Field
//                           name="password"
//                           component="input"
//                           type="text"
//                           placeholder="Enter Password"
//                           required
                          
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                     <FormGroup>
//                       <FormGroupLabel>Mobile No 2<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                       <FormGroupField>
//                         <Field
//                           name="mobile2"
//                           component={renderMaskedField}
//                           type="text"
//                           mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
//                           placeholder="Enter Mobile 2"
//                           required
                          
//                         />
//                       </FormGroupField>
//                     </FormGroup>
//                   </FormHalfContainer>
//                   <FormButtonToolbar>
//                     <Button variant="primary" type="submit" disabled={loading}>Submit</Button>
//                   </FormButtonToolbar>
//                 </FormContainer>
//               )}
//             </Form>
//           </CardBody>
//         </Card>
//       </Col>
      
//     );
//   };

//   EditUser.propTypes = {
//       onSubmit: PropTypes.func.isRequired,
//       userDetails: PropTypes.shape({
//         id: PropTypes.string.isRequired,
//         name: PropTypes.string.isRequired,
//         username: PropTypes.string.isRequired,
//         password: PropTypes.string, 
//         designation: PropTypes.string,
//         locationids: PropTypes.string,
//       }).isRequired,
//       loading: PropTypes.bool.isRequired,
//     };

//   export default EditUser;

